import React from "react";
import {
  TextField,
  ReferenceField,
  ReferenceManyField,
  Datagrid,
  DeleteButton,
  usePermissions
} from "react-admin";
import { Typography } from "@mui/material";
import { useClientContext } from "contexts/client";

export const titleCase = (string) => {
    const result =  string.split('_').map(word => (
        word[0].toUpperCase() + word.substr(1).toLowerCase()
    ))
   return result.join(' ')
};
export default function DistributorAssignments(props) {
  const { permissions } = usePermissions();
  const { state: clientState } = useClientContext();
  const featureList = clientState?.client?.featureList;
  const clientName = clientState?.client?.name;
  
  const distributorAssociations = featureList
    .filter(
      (feature) =>
        feature.attribute_class === "customer" &&
        feature.attribute_type === "category" &&
        feature.attribute_associations.includes("warehouse") &&
        feature.active === true
    )
    .map((feature) => feature);

  return (
    <div>
      {distributorAssociations.map((association) => {
        const { name } = association;

        return (
          <React.Fragment>
            <Typography variant="h6" gutterBottom>
              {titleCase(association.name)} Mapping
            </Typography>

            <ReferenceManyField
              fullWidth
              label={`${name}`}
              reference={`${clientName}_${name}_warehouse_mapping`}
              target={`warehouse_id`}
              perPage={100}
            >
              <Datagrid style={{tableLayout: 'fixed'}} bulkActionButtons={false} isRowSelectable={false}>
                <ReferenceField
                  label="Name"
                  source={`${name}_id`}
                  reference={`${clientName}_${name}`}
                  allowEmpty
                  sortable={false}
                >
                  <TextField source="name" />
                </ReferenceField>
                {permissions === "site_admin" 
                // || permissions === CLIENT_ADMIN_ROLE
                 ? (
                <DeleteButton redirect={false} />
              ) : null}
              </Datagrid>
            </ReferenceManyField>
            <div style={{ height: 30 }}></div>
          </React.Fragment>
        );
      })}
    </div>
  );
}
